module.exports = __webpack_public_path__ + "img/shopping_intro.21e5eda1.jpg";